"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserStatus = exports.UserRole = void 0;
exports.UserRole = {
    USER: 'USER',
    ADMIN: 'ADMIN',
};
exports.UserStatus = {
    정상: '정상',
    차단: '차단',
    삭제: '삭제',
};
